import { render, staticRenderFns } from "./settingMarkito.vue?vue&type=template&id=11d71904&scoped=true&"
import script from "./settingMarkito.vue?vue&type=script&lang=js&"
export * from "./settingMarkito.vue?vue&type=script&lang=js&"
import style0 from "./settingMarkito.vue?vue&type=style&index=0&id=11d71904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d71904",
  null
  
)

export default component.exports